<template>
  <pt-edit-password class="pt-edit-password__page"></pt-edit-password>
</template>

<script>
import PtEditPassword from 'cps//pt-edit-password/withData'
export default {
  name: 'pt-edit-password__view',
  components: {
    'pt-edit-password': PtEditPassword
  }
}
</script>
